module.exports = __webpack_public_path__ + "static/media/restock.b7d2e56a.png";